module.exports = __webpack_public_path__ + "static/media/i-yt.139e1421.svg";